module.exports = __webpack_public_path__ + "static/img/gx_sc@2x.45dac63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gx_sc@2x.png
// module id = i6lN
// module chunks = 2